import React, { useState, useEffect } from "react";
import styles from "../../../styles/patient-dashboard-modules/dashboard.module.css";
import CollapsableSection from "../../../components/collapsableSection";
import GeneralDetails from "../../../components/patient-detail/generalDetails";
import Summary from "../../../components/patient-detail/summary";
import Readings from "../../../components/patient-detail/readings";
// import CarePlan from "../../../components/patient-detail/careplan";
import { getPatientGeneralDetails } from "../../../services/patient/details";
import toast from "react-hot-toast";
import { BASE_URL, BASE_URL_ML } from "../../../utils/constants";
import axios from "axios";
import { handleApiError } from "../../../utils/handleApiError";
import CarePlanNew from "../../../components/patient-detail/careplanNew";

const PatientDashboard = () => {
  const isRPM = JSON.parse(localStorage.getItem("user"))?.rpm_enrolled;
  const isCCM = JSON.parse(localStorage.getItem("user"))?.ccm_enrolled;
  // Add new state for Readings collapse
  const [isReadingsOpen, setIsReadingsOpen] = useState(true);
  const [isCareplanOpen, setIsCareplanOpen] = useState(true);
  const [isSectionOpen, setIsSectionOpen] = useState({
    section_1: true,
    section_2: true,
  });
  const [activeTab, setActiveTab] = useState(isRPM ? "readings" : "careplan");

  const [patientUser, setPatientUser] = useState(null);
  // summary relates states
  const [summaryLoading, setSummaryLoading] = useState(false);
  const [summary, setSummary] = useState("");

  const schema_name = sessionStorage.getItem("schema_name");
  const patient_id = sessionStorage.getItem("_pt_id");

  // Generate Summary related functions
  useEffect(() => {
    const fetchSummary = async () => {
      const url = `${BASE_URL_ML}/chatbot/summary?db_schema=${schema_name}&patient_id=${patient_id}`;
      const mlFormData = new FormData();

      try {
        setSummaryLoading(true);
        const response = await axios.get(url, mlFormData);
        setSummary(response.data.summary);
      } catch (error) {
        handleApiError(error);
      } finally {
        setSummaryLoading(false);
      }
    };

    fetchSummary();
  }, []);

  useEffect(() => {
    const patientId = sessionStorage.getItem("_pt_id");

    if (patientId) {
      getPatientGeneralDetails(patientId)
        .then((response) => {
          const user = response?.user;
          setPatientUser(user);
        })
        .catch((error) => {
          console.error("Failed to fetch patient details", error);
        });
    }
  }, []);

  if (!patientUser) {
    return <div>Loading patient data...</div>;
  }

  const toggleSection = (sectionKey) => {
    setIsSectionOpen((prev) => ({
      ...prev,
      [sectionKey]: !prev[sectionKey],
    }));
  };

  return (
    <div className={styles.patient_dashboard_container}>
      <div className={styles.name_container_spacer}></div>

      <div className={styles.name_container}>
        <div className={styles.name_wrapper}>
          <div className={styles.name_and_status}>
            {/* 👇 Now showing patient name from API */}
            <h3>{`${patientUser.first_name} ${patientUser.last_name}`}</h3>
          </div>
        </div>
      </div>

      <div className={styles.patient_page_container}>
        <div className={styles.patient_page_section}>
          <div className={styles.section_1}>
            <div className={styles.section_1_left}>
              <CollapsableSection
                title={"General Details"}
                isOpen={isSectionOpen.section_1}
                onClose={() => toggleSection("section_1")}
                bodyHeight={"275px"}
                content={<GeneralDetails />}
              />
            </div>

            <div className={styles.section_1_right}>
              <CollapsableSection
                title={"Summary"}
                isOpen={isSectionOpen.section_2}
                onClose={() => toggleSection("section_2")}
                bodyHeight={"275px"}
                content={<Summary loading={summaryLoading} summary={summary} />}
              />
            </div>
          </div>
        </div>

        <div className={styles.section_2}>
          <div className={styles.section_2_left}>
            <div className={styles.tabSwitcher}>
              {isRPM && (
                <button
                  className={`${styles.tabButton} ${activeTab === "readings" ? styles.activeTab : ""
                    }`}
                  onClick={() => setActiveTab("readings")}
                >
                  Readings
                </button>
              )}

              {isCCM && (
                <button
                  className={`${styles.tabButton} ${activeTab === "careplan" ? styles.activeTab : ""
                    }`}
                  onClick={() => setActiveTab("careplan")}
                >
                  CarePlan
                </button>
              )}
            </div>

            {activeTab === "readings" && <Readings isSectionOpen={isReadingsOpen}
              onSectionClose={() => setIsReadingsOpen(prev => !prev)} />}
            {activeTab === "careplan" && <CarePlanNew isSectionOpen={isCareplanOpen} onSectionClose={() => setIsCareplanOpen(prev => !prev)}/>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PatientDashboard;
